// Maximallängen der Inputfelder

export default {
	userLoginName: 20,
	userPassword: 50,
	userFirstName: 50,
	userLastName: 50,
	userEmail: 100,
	userPhone: 50,
	organisationName: 200,
	organisationEmail: 200,
	organisationPhone: 50,
	organistationSuffix: 30,
	groupName: 200,
	groupEmail: 200,
	groupPhone: 50,
	contactName: 200,
	contactInfo: 200,
	contactEmail: 100,
	contactPhone: 50,
	addressZip: 11,
	addressCity: 200,
	addressNeighborhood: 200,
	addressStreet: 200,
	addressHouseNumber: 20,
	reportTitle: 100,
	reportUserComment: 5000,
	reportChatMessage: 10000,
	reportAssignmentNotice: 1000,
	reportDescription: 10000,
	issueChatMessage: 10000,
	meldooUserName: 50,
	meldooUserConnectionInfo: 200,
	pushNotificationMessage: 500,
	meldooWebHeaderTitle: 100,
	meldooWebHeaderSubTitle: 200,
	meldooWebSuccessMessage: 300,
	reportStatusInfo: 5000
};



// WEBPACK FOOTER //
// ./constants/InputSize.js